import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="filters"
export default class extends Controller {
  static targets = ["button"]
  static outlets = ["map"]
  static values = { }

  connect() {
    // console.log("filters")
    // console.log(this.buttonTargets)
  }

  update(event) {
    // console.log("filters update")
    // console.log(this.buttonTargets)
    // console.log(a)
    // this.mapOutlet.updateFilters(this.getFilters())
    // event.preventDefault()
    const elt = event.currentTarget
    if (elt.classList.contains('active')) {
      elt.classList.remove('active')
    } else {
      elt.classList.add('active')
    }
    // console.log(event)
    // if (t.classList.contains('active')) {
    //   filters.push(t.value)
    // }
    this.mapOutlet.updateUrl(0)
    // this.mapOutlet.updateUrl(0, (filters) => { console.log('test') })
  }

  getFilters() {
    const filters = []
    for (let t of this.buttonTargets) {
      // console.log(t)
      if (t.classList.contains('active')) {
        filters.push(t.value)
      }
    }
    return filters
  }

  // latlonValueChanged() {
  //   this.mapOutlet.updateMarkers(this.latlonValue)
  // }

  disconnect() {
  }
}
